<h1 mat-dialog-title>{{'header.user_menu.change_password'| translate}}</h1>
<div class="content" id="changePasswordModal" mat-dialog-content>
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <div class="content-row  flex-v-center">
      <mat-form-field appearance="outline">
        <mat-label>{{'password.change.oldPassword.label' | translate}}</mat-label>
        <input id="intOldPassword" #intOldPassword matInput formControlName="currentPassword"
          [type]="passwordHide1 ? 'password' : 'text'" />
          <mat-icon matSuffix (click)="passwordHide1 = !passwordHide1">{{passwordHide1 ? 'visibility_off' : 'visibility'}}
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="content-row  flex-v-center">
        <mat-form-field appearance="outline">
          <mat-label>{{'password.change.newPassword.label' | translate}}</mat-label>
          <input id="intNewPassword" matInput formControlName="newPassword"
            [type]="passwordHide2 ? 'password' : 'text'" />
            <mat-icon matSuffix (click)="passwordHide2 = !passwordHide2">{{passwordHide2 ? 'visibility_off' : 'visibility'}}
            </mat-icon>
          </mat-form-field>
        </div>
        <div class="content-row  flex-v-center">
          <mat-form-field appearance="outline">
            <mat-label>{{'password.change.repeatPassword.label' | translate}}</mat-label>
            <input id="intRepeatNewPassword" matInput formControlName="repeatPassword"
              [type]="passwordHide3 ? 'password' : 'text'" />
              <mat-icon matSuffix (click)="passwordHide3 = !passwordHide3">{{passwordHide3 ? 'visibility_off' : 'visibility'}}
              </mat-icon>
            </mat-form-field>
          </div>
        </form>
        @if (newPassword && newPassword.invalid && (newPassword.dirty || newPassword.touched) && newPassword.errors?.['minlength']) {
          <div
            class="alert alert-danger">
            {{'password.change.error.minLength' | translate}}
          </div>
        }
        @if (error) {
          <div class="alert alert-danger">
            {{error}}
          </div>
        }
        @if (form.errors?.['errorMsg']) {
          <div
            id="txtMismatch"
            class="alert alert-danger">
            {{ form.errors?.['errorMsg'] | translate}}
          </div>
        }
      </div>
      <div mat-dialog-actions>
        <button mat-button id="btnCloseChangePassword" (click)="onNoClick()">{{'general.label.cancel' | translate}}</button>
        <button mat-button id="btnSavePassword" dianaPreventDoubleClick  (click)="onSave()" [disabled]="form.invalid" cdkFocusInitial>{{'general.label.save' | translate}}</button>
      </div>